var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TreeView from '~/components/tree_view';
import { useToast } from '~/components_to_be_packaged/toast/provider';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import { useAppSidebar } from '../provider';
import AddProjectForm from './action/add';
import ArchiveProject from './action/archive';
import DeleteProject from './action/delete';
import MoveProject from './action/move';
import RenameProject from './action/rename';
export var MenuAction;
(function (MenuAction) {
    MenuAction["AddFolder"] = "Add folder";
    MenuAction["Rename"] = "Rename";
    MenuAction["Archive"] = "Archive";
    MenuAction["Unarchive"] = "Unarchive";
    MenuAction["Move"] = "Move";
    MenuAction["Delete"] = "Delete";
})(MenuAction || (MenuAction = {}));
const ProjectsWorkspaceMenu = ({ render }) => {
    const navigate = useNavigate();
    const { projectsWorkspaces, activeProjectWorkspaceId, isArchivedVisible, setActiveProjectWorkspaceId, updateProject, deleteProject, moveProject, } = useAppSidebar();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [visibleModalName, setVisibleModalName] = useState(null);
    const { activeTab } = useParams();
    const { hasPermission } = useUser();
    const { showToast } = useToast();
    if (!render) {
        return null;
    }
    const onNodeSelect = (project) => {
        navigate('/projects-workspace/' + (activeTab !== null && activeTab !== void 0 ? activeTab : 'document-comparison') + `/${project.id}`);
        setActiveProjectWorkspaceId(project.id);
    };
    const onMenuClick = (project, actionName) => {
        setSelectedProject(project);
        setVisibleModalName(actionName);
        setIsModalVisible(true);
    };
    const handleDeleteProject = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedProject)
            return;
        yield deleteProject(selectedProject.id);
        showToast({
            description: `Folder ${selectedProject.name} deleted`,
        });
        return null;
    });
    const handleArchiveProject = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedProject)
            return;
        yield updateProject(selectedProject.id, selectedProject.name, !selectedProject.isArchived);
        showToast({
            description: `Folder ${selectedProject.isArchived ? 'unarchived' : 'archived'}`,
        });
    });
    const handleMoveProject = (targetProject) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!selectedProject)
            return;
        yield moveProject(selectedProject.id, targetProject === null || targetProject === void 0 ? void 0 : targetProject.id);
        showToast({
            description: `Moved to ${(_a = targetProject === null || targetProject === void 0 ? void 0 : targetProject.name) !== null && _a !== void 0 ? _a : 'Projects'}`,
        });
        return null;
    });
    const handleRenameProject = (newName) => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedProject)
            return;
        yield updateProject(selectedProject.id, newName);
        showToast({
            description: 'Project renamed',
        });
        return null;
    });
    const showTree = () => {
        if (projectsWorkspaces === null)
            return React.createElement(React.Fragment, null);
        const turnIntoTreeNodes = (projWorks) => {
            var _a;
            return (_a = projWorks === null || projWorks === void 0 ? void 0 : projWorks.filter(p => isArchivedVisible || !p.isArchived)) === null || _a === void 0 ? void 0 : _a.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1).map(pw => {
                return {
                    id: pw.id,
                    name: pw.name,
                    children: turnIntoTreeNodes(pw.children),
                    isArchived: pw.isArchived,
                };
            });
        };
        const treeNodes = turnIntoTreeNodes(projectsWorkspaces);
        if (!treeNodes)
            return React.createElement(React.Fragment, null);
        const getMenuItems = (node) => {
            const menuItems = [];
            if (hasPermission(Permissions.RENAME_PROJECT_WORKSPACE)) {
                menuItems.push({ name: MenuAction.Rename });
            }
            if (hasPermission(Permissions.MOVE_PROJECT_WORKSPACE)) {
                menuItems.push({ name: MenuAction.Move });
            }
            if (hasPermission(Permissions.DELETE_PROJECT_WORKSPACE)) {
                menuItems.push({ name: MenuAction.Delete });
            }
            if (hasPermission(Permissions.ARCHIVE_PROJECT_WORKSPACE)) {
                menuItems.push({ name: node.isArchived ? MenuAction.Unarchive : MenuAction.Archive });
            }
            return menuItems;
        };
        return (React.createElement(TreeView, { additionalCollapseIcon: "fa-regular fa-folder-open", additionalExpandIcon: "fa-regular fa-folder", onNodeSelect: onNodeSelect, selectedId: activeProjectWorkspaceId !== null && activeProjectWorkspaceId !== void 0 ? activeProjectWorkspaceId : undefined, data: treeNodes, menu: getMenuItems, onMenuClick: onMenuClick }));
    };
    return (React.createElement("div", { className: 'nav-item-sub-menu' },
        React.createElement("div", { className: "add-new-project", onClick: () => { setVisibleModalName(MenuAction.AddFolder); setIsModalVisible(true); } },
            React.createElement("i", { className: "fa fa-plus-circle" }),
            "\u00A0Add new folder"),
        showTree(),
        visibleModalName === MenuAction.AddFolder &&
            React.createElement(AddProjectForm, { onHide: () => setIsModalVisible(false), isVisible: isModalVisible }),
        visibleModalName === MenuAction.Move &&
            selectedProject &&
            React.createElement(MoveProject, { onHide: () => setIsModalVisible(false), onMoveProject: handleMoveProject, isVisible: isModalVisible, selectedProjectId: selectedProject.id }),
        visibleModalName === MenuAction.Rename && selectedProject &&
            React.createElement(RenameProject, { onHide: () => setIsModalVisible(false), handleRenameProject: handleRenameProject, isVisible: isModalVisible, selectedProject: selectedProject }),
        visibleModalName === MenuAction.Delete &&
            React.createElement(DeleteProject, { onHide: () => setIsModalVisible(false), handleDeleteProject: handleDeleteProject, isVisible: isModalVisible }),
        (MenuAction.Archive === visibleModalName || MenuAction.Unarchive === visibleModalName) &&
            selectedProject &&
            React.createElement(ArchiveProject, { onHide: () => setIsModalVisible(false), handleArchiveProject: handleArchiveProject, selectedProject: selectedProject, isVisible: isModalVisible })));
};
export default ProjectsWorkspaceMenu;
